import { Box, Typography } from "@mui/material";

const formatNumber = (number) => number.toFixed(2);

const Step4Form = ({
  kilnVolume,
  biocharYieldLevel,
  numberOfKilns,
  laborCosts,
  burnSupervisorCosts,
  otherCosts,
  measurementSystem,
  currency,
  bulkDensity,
  capitalCosts,
}) => {
  const currencySymbols = {
    "R-ZAR": "R",
    "$-USD": "$",
    "$-AUS": "$",
  };

  const currencySymbol = currencySymbols[currency];
  const measurementUnit = measurementSystem === "Metric" ? "m³" : "yd³";

  const totalBiocharProduced =
    kilnVolume * (biocharYieldLevel / 100) * numberOfKilns;
  const totalDailyCost =
    parseFloat(laborCosts) +
    parseFloat(burnSupervisorCosts) +
    parseFloat(otherCosts);
  const costOfDailyBiocharProduction = totalDailyCost / totalBiocharProduced;

  const estimatedBiocharMass =
    parseFloat(bulkDensity) * parseFloat(totalBiocharProduced);
  const estimatedCO2RemovalAmount = estimatedBiocharMass * 2;
  const totalKilnCapex = parseFloat(numberOfKilns) * parseFloat(capitalCosts);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: 2, px: 3 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
        <Typography variant="h6" gutterBottom>
          Results
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', width: 380, gap: 1 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography>
            Total biochar produced:
          </Typography>
          <Typography>
            {formatNumber(totalBiocharProduced)} {measurementUnit}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography>
            Total daily cost:
          </Typography>
          <Typography>
            {currencySymbol}{formatNumber(totalDailyCost)}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography>
            Cost of daily biochar production:
          </Typography>
          <Typography>
            {currencySymbol}{formatNumber(costOfDailyBiocharProduction)}/{measurementUnit}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography>
            Total CAPEX for kilns:
          </Typography>
          <Typography>
            {currencySymbol}{formatNumber(totalKilnCapex)}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography>
            Estimated biochar mass:
          </Typography>
          <Typography>
            {formatNumber(estimatedBiocharMass)} {measurementSystem === "Metric" ? "kg" : "lb"}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography>
            Estimated CO2 Removal Amount:
          </Typography>
          <Typography>
            {formatNumber(estimatedCO2RemovalAmount)} {measurementSystem === "Metric" ? "kg" : "lb"} CO2
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Step4Form;
